<template>
  <v-row>
    <v-col cols="12">
      <div class="d-flex align-center">
        <h3 class="pl-2">
          {{ $t("message.companyProfile.monitoredKeywords.subtitle") }}
        </h3>
        <v-tooltip top :max-width="360">
          <template v-slot:activator="{ on }">
            <v-icon small color="accent" v-on="on" class="ml-3">
              mdi-information
            </v-icon>
          </template>
          <span>
            {{ $t("message.companyProfile.monitoredKeywords.subtitleTooltip") }}
          </span>
        </v-tooltip>
      </div>

      <v-row>
        <!-- <v-col cols="6" lg="4">
          <section class="section section--first">
            TODO: Keywords scope selection
          </section>
        </v-col> -->
        <v-col cols="12" :lg="center ? 12 : 8">
          <section class="section">
            <div class="d-flex align-center">
              <v-text-field
                v-model="newKeyword"
                @keyup.enter="addKeyword"
                :label="
                  $t(
                    'message.companyProfile.monitoredKeywords.keywordsSection.keywordInputPlaceholder'
                  )
                "
                clearable
                class="mt-4 mb-4"
                data-cy="word-input"
                :hide-details="true"
              ></v-text-field>
              <ui-button
                class="ml-3 min-w-130"
                color="primary"
                data-cy="word-submit"
                @click="addKeyword"
                :disabled="!newKeyword"
                >{{ $t("message.common.add") }}</ui-button
              >
            </div>
            <InfoBox
              class="my-2"
              :text="
                $t(
                  'message.companyProfile.monitoredKeywords.keywordsSection.infoBoxContent'
                )
              "
            />
            <div
              v-if="loaded && keywords && keywords.length > 0"
              class="d-flex flex-wrap"
              data-cy="word-container"
            >
              <v-chip
                v-for="(keyword, index) in keywords"
                :key="`${keyword}_${index}`"
                outlined
                class="mr-2 my-1"
              >
                {{ keyword.keyword.name }}
                <v-icon
                  class="ml-2 mr--1"
                  color="grey"
                  @click="handleDeleteKeywordClick(keyword)"
                >
                  icon-close
                </v-icon>
              </v-chip>
            </div>
            <div
              class="no-keywords"
              v-else-if="loaded && keywords && keywords.length === 0"
            >
              <img
                src="@/static/keywords/noKeywords.png"
                :alt="
                  $t(
                    'message.companyProfile.monitoredKeywords.keywordsSection.noKeywordsAlt'
                  )
                "
              />
              <p>
                {{
                  $t(
                    "message.companyProfile.monitoredKeywords.keywordsSection.noKeywords"
                  )
                }}
              </p>
            </div>
          </section>
        </v-col>
      </v-row>

      <SectionLoader :status="loading" :opacity="0.75" />
    </v-col>
    <DeleteKeywordDialog
      :isOpen="dialog.deleteKeyword"
      @cancel="cancelDeletingKeyword"
      @delete="deleteKeyword"
    />
  </v-row>
</template>

<script>
import DeleteKeywordDialog from "@/components/Keywords/DeleteKeywordDialog";
import InfoBox from "@/components/ui/InfoBox";
import SectionLoader from "@/components/Loader/SectionLoader";

import { companyInWeb } from "@/helpers/mixins/company-in-web";

export default {
  name: "MonitoredKeywords",
  mixins: [companyInWeb],
  props: {
    center: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DeleteKeywordDialog,
    InfoBox,
    SectionLoader
  }
};
</script>

<style lang="scss" scoped>
.section {
  display: flex;
  flex-direction: column;
  padding-left: $spacing;
  padding-bottom: $spacing;

  &--first {
    height: 100%;
    border-right: 1px solid $light-3;
  }

  &__title {
    @include sectionTitle();
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: $spacing * 2;
    margin-left: $spacing * 2;
  }
}

.no-keywords {
  @include noData(200px);
  margin-top: $spacing * 2;

  img {
    max-height: 250px;
  }

  p {
    @include font-size(22px);
    text-align: center;
    margin: $spacing * 5 0 $spacing * 3;
  }
}

.v-chip {
  @include vChip();
  white-space: pre-wrap;
}

.mr--1 {
  margin-right: $spacing * -0.75;
}

.min-w-130 {
  min-width: 130px !important;
}
</style>
